import { createRouter, createWebHistory } from 'vue-router'

import IndexView from '../views/projects/ProjectIndexView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import ProjectDetailView from '../views/projects/ProjectDetailView.vue'
import { authRoutes } from '@haskoning/vue-authentication-middleware'
import { storeToRefs } from 'pinia'
import CalculationIndexView from '@/views/projects/CalculationIndexView.vue'
import UserManagementView from '@/views/projects/UserManagementView.vue'
import MaterialsView from '@/views/projects/MaterialsView.vue'
import { useProjectStore } from '@/stores/project'
import CostsAndCO2View from '@/views/projects/CostsAndCO2View.vue'
import VesselView from '@/views/projects/VesselView.vue'
import CalculationDetailView from '@/views/calculations/CalculationDetailView.vue'
import CalculationFormView from '@/views/calculations/CalculationFormView.vue'
import CalculationResultView from '@/views/calculations/CalculationResultView.vue'
import { useDjangoAuthStore } from '@/stores/authDjango'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundView,
      name: 'not-found'
    },
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'auth-login'
      }
    },
    authRoutes,
    {
      path: '/project-index',
      name: 'project-index',
      component: IndexView,
      beforeEnter: (to, from) => {
        const store = useProjectStore()
        store.resetAll()
        return true
      }
    },
    {
      path: '/project/:id',
      name: 'project-detail',
      component: ProjectDetailView,
      redirect: {
        name: 'calculation-index'
      },
      children: [
        {
          path: '/project/:id',
          name: 'calculation-index',
          component: CalculationIndexView
        },
        {
          path: '/project/:id/materials',
          name: 'materials',
          component: MaterialsView
        },
        {
          path: '/project/:id/costs',
          name: 'costs',
          component: CostsAndCO2View
        },
        {
          path: '/project/:id/vessel',
          name: 'vessel',
          component: VesselView
        },
        {
          path: '/project/:id/user-management',
          name: 'user-management',
          component: UserManagementView
        }
      ]
    },
    {
      path: '/project/:id/calculation/:calculationId',
      name: 'calculation-detail',
      component: CalculationDetailView,
      redirect: {
        name: 'calculation-result'
      },
      children: [
        {
          path: '/project/:id/calculation/:calculationId/form',
          name: 'calculation-form',
          component: CalculationFormView
        },
        {
          path: '/project/:id/calculation/:calculationId/result',
          name: 'calculation-result',
          component: CalculationResultView
        }
      ]
    }
  ]
})

router.beforeEach(async (to) => {
  const authStore = useDjangoAuthStore()
  const { user } = storeToRefs(authStore)

  if (!user?.value?.id) {
    const userResponse = await authStore.reAuthenticate()
    await authStore.authenticateShipApi()
    if (userResponse) {
      authStore.$patch({
        user: userResponse.user
      })
    }
  }
  if (to.name?.startsWith('auth-')) {
    if (user.value) {
      return { name: 'project-index' }
    }
    return true
  }
  // check auth and apply login redirect
  if (!user.value) {
    authStore.loginRedirect = to
    return { name: 'auth-login' }
  }
  return true
})

export default router
